
      import API from "!../../../Aphrodite.Admin.Web/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../Aphrodite.Admin.Web/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../Aphrodite.Admin.Web/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../Aphrodite.Admin.Web/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../Aphrodite.Admin.Web/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../Aphrodite.Admin.Web/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../Aphrodite.Admin.Web/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../Aphrodite.Admin.Web/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[2].use[2]!../../../Aphrodite.Admin.Web/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[2].use[3]!./Slider.module.scss";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../Aphrodite.Admin.Web/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../Aphrodite.Admin.Web/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[2].use[2]!../../../Aphrodite.Admin.Web/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[2].use[3]!./Slider.module.scss";
       export default content && content.locals ? content.locals : undefined;
